export class LabClassifier {
    static classifyBrightness(mean) {
        if (mean > 143) return "BRIGHT";
        if (mean < 113) return "DARK";
        return "NEUTRAL";
    }

    static classifyRange(range) {
        if (range >= 240) return "COMPLETE";
        if (range >= 180) return "PARTIAL";
        return "LIMITED";
    }

    static classifySkewness(skewness) {
        if (skewness > 0.5) return "DARK_BIASED";
        if (skewness < -0.5) return "LIGHT_BIASED";
        return "BALANCED";
    }

    static classifyKurtosis(kurtosis) {
        if (kurtosis > 0.5) return "CONCENTRATED";
        if (kurtosis < -0.5) return "GENTLE";
        return "FLAT";
    }

    static classifyATone(value) {
        if (value >= 126 && value <= 130) return "NEUTRAL";
        if (value >= 123 && value < 126) return "SLIGHT_GREEN";
        if (value > 130 && value <= 133) return "SLIGHT_RED";
        if (value < 85) return "STRONG_GREEN";
        if (value > 170) return "STRONG_RED";
        return value < 128 ? "GREEN" : "RED";
    }

    static classifyBTone(value) {
        if (value >= 126 && value <= 130) return "NEUTRAL";
        if (value >= 123 && value < 126) return "SLIGHT_BLUE";
        if (value > 130 && value <= 133) return "SLIGHT_YELLOW";
        if (value < 85) return "STRONG_BLUE";
        if (value > 170) return "STRONG_YELLOW";
        return value < 128 ? "BLUE" : "YELLOW";
    }

    // static classifyColorRange(range) {
    //     if (range <= 50) return "集中，色彩表现一致，整体感和谐统一";
    //     if (range <= 100) return "较分散，色彩覆盖更广，增加了层次感";
    //     return "非常分散，色彩分布复杂，视觉效果丰富多样";
    // }

    static classifyToneIntensity(mainTone) {
        switch (mainTone) {
            case "STRONG_GREEN":
            case "STRONG_RED":
                return "STRONG";
            case "GREEN":
            case "RED":
                return "MODERATE";
            case "SLIGHT_GREEN":
            case "SLIGHT_RED":
                return "WEAK";
            case "NEUTRAL":
            default:
                return "WEAK";
        }
    }

    static classifyTemperatureIntensity(colorTemperatureTone) {
        switch (colorTemperatureTone) {
            case "STRONG_YELLOW":
            case "STRONG_BLUE":
                return "STRONG";
            case "YELLOW":
            case "BLUE":
                return "MODERATE";
            case "SLIGHT_YELLOW":
            case "SLIGHT_BLUE":
                return "WEAK";
            case "NEUTRAL":
            default:
                return "WEAK";
        }
    }

    static classifyTemperatureContrast(colorTemperatureTone) {
        if (colorTemperatureTone === "YELLOW" || colorTemperatureTone === "BLUE" ||
            colorTemperatureTone === "SLIGHT_YELLOW" || colorTemperatureTone === "SLIGHT_BLUE" ||
            colorTemperatureTone === "STRONG_YELLOW" || colorTemperatureTone === "STRONG_BLUE") {
            return true;
        }
        return false;
    }

    static classifyColorDistribution(iqr) {
        if (iqr <= 50) return "CONCENTRATED";
        if (iqr <= 100) return "SCATTERED";
        return "VERY_SCATTERED";
    }

    static extractHighlights(analysis) {
        const highlights = [];
        const { a, b } = analysis;
    
        if (a.statistics.max > 180 && a.statistics.max > a.statistics.mean + 20 && a.classification.mainTone !== "RED") {
            highlights.push({
                color: 'red',
                channel: 'a',
                value: a.statistics.max
            });
        }
        if (b.statistics.max > 180 && b.statistics.max > b.statistics.mean + 20 && b.classification.colorTemperatureTone !== "YELLOW") {
            highlights.push({
                color: 'yellow',
                channel: 'b',
                value: b.statistics.max
            });
        }
    
        return highlights.length > 0 ? highlights : null;
    }

    static extractLowlights(analysis) {
        const lowlights = [];
        const { a, b } = analysis;
    
        if (a.statistics.min < 70 && a.statistics.min < a.statistics.mean - 20 && a.classification.mainTone !== "GREEN") {
            lowlights.push({
                color: 'green',
                channel: 'a',
                value: a.statistics.min
            });
        }
        if (b.statistics.min < 70 && b.statistics.min < b.statistics.mean - 20 && b.classification.colorTemperatureTone !== "BLUE") {
            lowlights.push({
                color: 'blue',
                channel: 'b',
                value: b.statistics.min
            });
        }
    
        return lowlights.length > 0 ? lowlights : null;
    }

    static assessColorBalance(analysis) {
        const highlights = this.extractHighlights(analysis);
        const lowlights = this.extractLowlights(analysis);
    
        return {
            highlights,
            lowlights,
            balanceType: highlights && lowlights ? "both" : highlights ? "highlights" : lowlights ? "lowlights" : "neutral",
        };
    }
} 